export const GreenCircleTickIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        >
        <g clip-path="url(#clip0_264_477)">
            <path
            d="M7.5 0C3.36437 0 0 3.36437 0 7.5C0 11.6356 3.36437 15 7.5 15C11.6356 15 15 11.6356 15 7.5C15 3.36437 11.6356 0 7.5 0ZM7.44313 9.63688C7.20125 9.87875 6.88312 9.99937 6.56375 9.99937C6.24437 9.99937 5.92313 9.8775 5.67875 9.63375L3.94 7.94875L4.81063 7.05062L6.55625 8.7425L10.1869 5.17937L11.0644 6.07L7.44313 9.63688Z"
            fill="#05A732"
            />
        </g>
        <defs>
            <clipPath id="clip0_264_477">
            <rect width="15" height="15" fill="white" />
            </clipPath>
        </defs>
        </svg>
    `,
      }}
    />
  );
};
